import React from "react";
import Modal from "react-native-modal";
import ResponsiveContent from "../shared/responsive-content";
import { View, Pressable, Text } from "react-native";
import CloseIcon from "@/assets/svgs/close-icon";
import { Button } from "../ui/button";

function LessonCancelledModal({
  isVisible,
  lateCancellation,
  onClose,
  onDismiss,
}: {
  isVisible: boolean;
  lateCancellation: boolean;
  onClose: () => void;
  onDismiss: () => void;
}) {
  return (
    <Modal
      animationIn="slideInUp"
      animationOut="slideOutDown"
      isVisible={isVisible}
      onBackdropPress={onClose}
      onDismiss={() => {
        onDismiss();
      }}
      useNativeDriver
      useNativeDriverForBackdrop
      hideModalContentWhileAnimating
    >
      <ResponsiveContent>
        <View className="mx-4 bg-teachLoop-creamBase rounded-xl px-8 py-10">
          <View className="items-end">
            <Pressable
              onPress={onClose}
              className="active:opacity-80"
              style={{ marginHorizontal: -12 }}
            >
              <CloseIcon
                pathClassName="stroke-teachLoop-textPrimary"
                className="size-6"
              />
            </Pressable>
          </View>
          <View className="gap-8">
            <Text className="font-zilla-slab-medium font-medium text-[28px] leading-[1.2] text-black">
              Lesson cancelled!
            </Text>
            {lateCancellation ? (
              <Text className="text-base font-geologica-regular font-normal leading-[1.5] text-teachLoop-textPrimary">
                Loopedin Learning will review the cancellation and be in touch
                with you.
                {"\n"}
                {"\n"}
                The lesson card will automatically be removed from your
                schedule.
              </Text>
            ) : (
              <Text className="text-base font-geologica-regular font-normal leading-[1.5] text-teachLoop-textPrimary">
                The lesson card has been removed from your schedule.
              </Text>
            )}
            <Button fullWidth size="md" intent="primary" onPress={onClose}>
              <Button.Text size="md">Okay</Button.Text>
            </Button>
          </View>
          <View className="h-3" />
        </View>
      </ResponsiveContent>
    </Modal>
  );
}

export default LessonCancelledModal;
